import React from "react";
import BookSimulator from '../Controls/Simulators/BookSimulator';
import { ResourceEditorPanel } from '../Data/DataDisplay/ResourceEditorPanel';
import { useSkitterBookLivePages } from '../Data/DataProviders/SkitterBookLivePagesDataProvider';
import './css/SkitterBookLiveSimulator.css';

interface SkitterBookLiveSimulatorProps {
    useFlipVibration: boolean | null;
    imageMarginMm: number;
}

const SkitterBookLiveSimulator: React.FC<SkitterBookLiveSimulatorProps> = ({ useFlipVibration = true, imageMarginMm }) => {

    const pagesController = useSkitterBookLivePages();

    return (
        <div className="skitterbook-simulator-container">
            <ResourceEditorPanel controller={pagesController}>
                {
                    ({ data: pages }) => (
                        <div className="skitterbook-simulator-inner-container">
                            <BookSimulator images={pages.skitterPages}
                                imageMarginMm={imageMarginMm}
                                useFlipVibration={useFlipVibration} />
                            {pages && pages.isSample ? <a href="https://www.vecteezy.com/free-videos">Stock Videos by Vecteezy</a> : <></>}
                        </div>
                    )
                }
            </ResourceEditorPanel>
        </div>
    );
};

export default SkitterBookLiveSimulator;
